// src/apiClient.js
import axios from 'axios'

// ✅ Use same-origin in production (nginx proxies /api -> 127.0.0.1:5050)
// If you want local dev, set REACT_APP_API_BASE_URL=http://localhost:5050
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
})
export const fetchReceiptSummary = async (receiptId) => {
  return (await api.get('/api/payment-receipts/summary', { params: { receiptId } })).data
}
// Optional: helpful debugging (you can remove later)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Keeps a clean error but still lets your page read err.response.data
    console.error('[API ERROR]', {
      url: err?.config?.url,
      baseURL: err?.config?.baseURL,
      status: err?.response?.status,
      data: err?.response?.data,
      message: err?.message,
    })
    return Promise.reject(err)
  }
)

// --- Generic helpers ---
export const get = (url, config = {}) => api.get(url, config)
export const post = (url, data, config = {}) => api.post(url, data, config)
export const put = (url, data, config = {}) => api.put(url, data, config)
export const del = (url, config = {}) => api.delete(url, config)

// =========================
// VEHICLES
// =========================
export const fetchVehicles = async (arg1, arg2) => {
  let params = {}
  if (typeof arg1 === 'object' && arg1 !== null) params = arg1
  else if (arg1 && arg2) params = { userId: arg1, role: arg2 }

  const res = await api.get('/api/vehicles', { params })
  return res.data
}

export const createVehicle = async (payload) => (await api.post('/api/vehicles', payload)).data
export const updateVehicle = async (id, payload) => (await api.put(`/api/vehicles/${id}`, payload)).data
export const deleteVehicle = async (id) => (await api.delete(`/api/vehicles/${id}`)).data

// =========================
// PAYMENTS
// =========================
export const fetchPayments = async (arg1, arg2) => {
  let params = {}
  if (typeof arg1 === 'object' && arg1 !== null) params = arg1
  else if (arg1 && arg2) params = { userId: arg1, role: arg2 }

  const res = await api.get('/api/payments', { params })
  return res.data
}

// ✅ receipts endpoint
export const createPaymentReceipt = async (payload) => {
  const res = await api.post('/api/payment-receipts', payload)
  return res.data
}
export const deletePaymentReceipt = async (receiptId, params = {}) => {
  const res = await api.delete(`/api/payment-receipts/${receiptId}`, { params })
  return res.data
}
export const updatePayment = async (id, payload) => (await api.put(`/api/payments/${id}`, payload)).data
export const deletePayment = async (id) => (await api.delete(`/api/payments/${id}`)).data

// =========================
// CARRY FORWARD BALANCES
// =========================
export const fetchCarryForwardBalances = async (arg1, arg2) => {
  let params = {}
  if (typeof arg1 === 'object' && arg1 !== null) params = arg1
  else if (arg1 && arg2) params = { userId: arg1, role: arg2 }

  const res = await api.get('/api/carry-forward-balances', { params })
  return res.data
}

// =========================
// DASHBOARD
// =========================
export const fetchDashboardSummary = async (userId, role) => {
  const params = userId && role ? { userId, role } : {}
  return (await api.get('/api/dashboard/summary', { params })).data
}

export const getRecentPayments = async (userId, role) => {
  const params = userId && role ? { userId, role } : {}
  return (await api.get('/api/dashboard/recent-payments', { params })).data
}

export const fetchDashboardMonthlyStats = async (userId, role) => {
  const params = userId && role ? { userId, role } : {}
  return (await api.get('/api/dashboard/monthly-stats', { params })).data
}

// =========================
// APPROVED USERS
// =========================
export const fetchApprovedUsers = async (role = 'super_admin') => {
  return (await api.get('/api/approved-users', { params: { role } })).data
}

// =========================
// REPORTS
// =========================
export const fetchGeneralReport = async (params = {}) =>
  (await api.get('/api/reports/general', { params })).data

export const fetchSpecificVehicleReport = async (vehicleId, params = {}) =>
  (await api.get('/api/reports/specific-vehicle', { params: { vehicleId, ...params } })).data

export const fetchMissingPaymentsReport = async (params = {}) =>
  (await api.get('/api/reports/missing-payments', { params })).data

export const fetchProfitLossReport = async (params = {}) =>
  (await api.get('/api/reports/profit-loss', { params })).data

// =========================
// HEALTH CHECK
// =========================
export const checkHealth = async () => (await api.get('/api/health')).data

export default api